import { createRouter, createWebHistory } from 'vue-router'

import { IMOCKUP_PUBLIC_SITE_NAME } from '@/config/imockupBuildFlags'
import HomeView from '@/views/HomeView.vue'
import OAuthGithubCallbackView from '@/views/OAuthGithubCallbackView.vue'
import OAuthWechatCallbackView from '@/views/OAuthWechatCallbackView.vue'
import { editorDocumentLangForUiLocale, editorPathToUiLocale } from '@/router/editorUrlLocale'
import { useMockupEditorStore } from '@/stores/mockupEditor'

const homeMeta = { title: 'Home' } as const

const oauthGithubMeta = { title: 'GitHub' } as const
const oauthWechatMeta = { title: 'WeChat' } as const

/**
 * 应用路由表；URL 语种段与营销站 `prefix_except_default` 对齐（`/` 为英语，`/zh-CN`、`/ja` 为对应语种）。
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/zh-CN',
      name: 'home-zh-CN',
      component: HomeView,
      meta: homeMeta,
    },
    {
      path: '/ja',
      name: 'home-ja',
      component: HomeView,
      meta: homeMeta,
    },
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: homeMeta,
    },
    {
      path: '/oauth/github/callback',
      name: 'oauth-github-callback',
      component: OAuthGithubCallbackView,
      meta: oauthGithubMeta,
    },
    {
      path: '/zh-CN/oauth/github/callback',
      name: 'oauth-github-callback-zh',
      component: OAuthGithubCallbackView,
      meta: oauthGithubMeta,
    },
    {
      path: '/ja/oauth/github/callback',
      name: 'oauth-github-callback-ja',
      component: OAuthGithubCallbackView,
      meta: oauthGithubMeta,
    },
    {
      path: '/oauth/wechat/callback',
      name: 'oauth-wechat-callback',
      component: OAuthWechatCallbackView,
      meta: oauthWechatMeta,
    },
    {
      path: '/zh-CN/oauth/wechat/callback',
      name: 'oauth-wechat-callback-zh',
      component: OAuthWechatCallbackView,
      meta: oauthWechatMeta,
    },
    {
      path: '/ja/oauth/wechat/callback',
      name: 'oauth-wechat-callback-ja',
      component: OAuthWechatCallbackView,
      meta: oauthWechatMeta,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'catch-all',
      redirect: (to) => ({ path: '/', query: to.query, hash: to.hash }),
    },
  ],
})

router.beforeEach((to) => {
  const ui = editorPathToUiLocale(to.path)
  useMockupEditorStore().setLocale(ui)
})

router.afterEach((to) => {
  const base = import.meta.env.VITE_APP_TITLE || IMOCKUP_PUBLIC_SITE_NAME
  document.title = typeof to.meta.title === 'string' ? `${base} · ${to.meta.title}` : base
  document.documentElement.lang = editorDocumentLangForUiLocale(editorPathToUiLocale(to.path))
})

export default router
